import { Logger, LoggerService } from "@Shared/logger";
import { AppleService } from "./services/apple.service";

export class AppleModuleClass {
    private Logger: Logger = LoggerService.createLogger("AppleModule");

    constructor() {
        this.Logger.trace("****  CTOR ****");
    }

    public async init(): Promise<void> {
        this.Logger.trace("Apple Module Initializing");
        try {
            // touch the service so the singleton + repo are constructed up-front
            AppleService.Instance;
            return Promise.resolve();
        } catch (error) {
            return Promise.reject(error);
        }
    }
}

export const AppleModule = new AppleModuleClass();
